import './App.css';
import TimeBlock from './TimeBlock';

function App() {
  return (
    <div className="App">
        <TimeBlock />
    </div>
  );
}

export default App;
